let menuNavegacion = false;

document.addEventListener('DOMContentLoaded', () => iniciarApp());


function iniciarApp(){
    mostrarNavegacion();
    scrollNav();
    menu();
    darkMode();
    animaciones();
    descargarCV();
    idiomas();
}

function idiomas(){
    const btnCambiarIdioma = document.querySelector('.btn-cambiar');
    btnCambiarIdioma.addEventListener('click', () => {
        const opcionesIdiomas = document.querySelector('ul.idiomas-nav');
        opcionesIdiomas.classList.toggle('mostrar-idiomas');
        btnCambiarIdioma.classList.toggle('btn-cambiar-active');
        cambiarIdioma();
    });
}

function cambiarIdioma(){
    const idiomas = document.querySelectorAll('li.idioma');
    idiomas.forEach(idioma => {
        idioma.addEventListener('click', e => {
            if(idioma.children[1].dataset.idioma == 'es'){
                setCookieIdioma('es');
            }else if(idioma.children[1].dataset.idioma == 'en'){
                setCookieIdioma('en');
            }else if(idioma.children[1].dataset.idioma == 'de'){
                setCookieIdioma('de');
            }else{
                setCookieIdioma('es');
            }
            window.location.reload();
        });
    });
}

function setCookieIdioma(idioma){
    document.cookie = `language=${idioma};expires=` + new Date(new Date().getTime() + 3600 * 1000).toUTCString();
}

function darkMode(){
    // const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const darkModeButton = document.querySelector('.darkmode-button');
    darkModeButton.addEventListener('click', () =>{
        const darkmode = document.body.classList.contains('dark-mode') ? false : true;
        document.body.classList.toggle("dark-mode");
        document.cookie = `dark-mode=${darkmode};expires=` + new Date(new Date().getTime() + 3600 * 1000).toUTCString();
    });
}

function menu(){
    const menuIcon = document.querySelector('.menu');
    menuIcon.addEventListener('click', () => {
        const nav = document.querySelector('.navegacion');
        const nav2 = document.querySelector('.navegacion-oculta');
        const opcionesIdiomas = document.querySelector('ul.idiomas-nav');
        const btnCambiarIdioma = document.querySelector('.btn-cambiar');
        menuNavegacion = !menuNavegacion;
        nav.classList.toggle('complete-nav');
        nav2.classList.toggle('ocultar-nav');
        opcionesIdiomas.classList.remove('mostrar-idiomas');
        btnCambiarIdioma.classList.remove('btn-cambiar-active');
    });
}

function descargarCV(){
    const btnCV = document.querySelector('.btn-cv');
    btnCV.addEventListener('click', (e) => {
        e.preventDefault();
        const opcionesDIV = document.querySelector('.opcionesDIV');
        opcionesDIV.classList.toggle('mostrarOpcionesCV');
        btnCV.classList.toggle('activeOpcionesCV');
        const opciones = document.querySelectorAll('.opcionesDIV li');
        opciones.forEach(opcion => {
            opcion.addEventListener('click', e => {
                opcionesDIV.classList.remove('mostrarOpcionesCV');
                btnCV.classList.remove('activeOpcionesCV');
                if(e.target.dataset.idioma === 'es'){
                    window.open('/archivos/CV.pdf', '_blank');
                }else if(e.target.dataset.idioma === 'en'){
                    window.open('/archivos/CV-EN.pdf', '_blank');
                }
            });
        });

    });
}

function mostrarNavegacion(){
    const nav = document.querySelector('.navegacion');
    const header = document.querySelector('header');
    let scrollPos = 0;

    window.addEventListener('scroll', function(){
        if (header.getBoundingClientRect().top <= -50 && !menuNavegacion){
            // estado = nav.classList.value.includes('mostrar-nav');
            if ((document.body.getBoundingClientRect()).top > scrollPos){
                // ARRIBA
                nav.classList.remove('ocultar-nav');
            }else{
                // ABAJO
                nav.classList.add('ocultar-nav');
            }
        }
        scrollPos = (document.body.getBoundingClientRect()).top;
    });
}

function scrollNav(){
    const enlaces = document.querySelectorAll('.navegacion a');
    enlaces.forEach(enlace => {
        enlace.addEventListener('click',e => {
            e.preventDefault();
            let seccion;
            if(e.target.nodeName === 'IMG'){
                seccion = document.querySelector(e.target.parentElement.parentElement.parentElement.attributes.href.value);
            }else{
                seccion = document.querySelector(e.target.attributes.href.value);
            }
            seccion.scrollIntoView({behavior : "smooth"});
        });
    });
}

function animaciones(){
    const imagenSobremi = document.querySelector('#imagen-sobremi');
    const proyectos = document.querySelector('#lista-proyectos-main');
    const habilidades = document.querySelectorAll('.tecnologia');
    const blandas = document.querySelectorAll('.blanda');
    const idiomas = document.querySelector('.idiomas');

    const soy = document.querySelector('#texto-soy');
    const textoProgramador = document.querySelector('#titulo-pagina');
    const tituloPagina = document.querySelector('#texto-programador');
    const textoSobremi = document.querySelector('#texto-sobremi');
    const headingSobremi = document.querySelector('#heading-sobremi');
    const speed = 120*2;


    const cargarImagen = (entradas, observador) => {
        entradas.forEach(entrada =>{
            if(entrada.isIntersecting){
                entrada.target.classList.add('animacion-visible');
            }
        });
    };

    const observador = new IntersectionObserver(cargarImagen, {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshols: 1.0
    });

    const cargarTexto = (entradas, observadorTexto) => {
        entradas.forEach(entrada =>{
            if(entrada.isIntersecting){
                entrada.target.classList.remove('opacity-0');
                if((entrada.target.id === 'texto-sobremi') && entrada.target.classList.contains('animar-texto')){
                    animacionTexto(entrada.target, speed/1000);
                }else if ((entrada.target.id === 'texto-soy' ) && entrada.target.classList.contains('animar-texto')){
                    animacionTexto(entrada.target, speed/5);
                }else if((entrada.target.id === 'titulo-pagina') && entrada.target.classList.contains('animar-texto')){
                    animacionTexto(entrada.target, speed/5);
                }else if((entrada.target.id === 'texto-programador') && entrada.target.classList.contains('animar-texto')){
                    animacionTexto(entrada.target, speed/5);
                }else if((entrada.target.id === 'heading-sobremi') && entrada.target.classList.contains('animar-texto')){
                    animacionTexto(entrada.target, speed/5);
                }
                entrada.target.classList.remove('animar-texto');
            }
        });
    };

    const observadorTexto = new IntersectionObserver(cargarTexto, {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshols: 1.0
    });

    observadorTexto.observe(soy);
    observadorTexto.observe(textoProgramador);
    observadorTexto.observe(tituloPagina);
    observadorTexto.observe(textoSobremi);
    observadorTexto.observe(headingSobremi);

    observador.observe(imagenSobremi);
    observador.observe(proyectos);
    observador.observe(idiomas);
    habilidades.forEach(habilidad => {
        observador.observe(habilidad);
    });

    // idiomas.forEach(idioma => {
    //     observador.observe(idioma);
    // });

    blandas.forEach(blanda => {
        observador.observe(blanda);
    });
}

function animacionTexto(text, speed ){
    let str = text.innerHTML;
    str = str.replace("<span>", "");
    str = str.replace("</span>", "");
    str = str.replace("</span>", "");
    str = str.replace("</span>", "");
    str = str.replace('<span class="carrera">', "");
    str = str.replace('<span class="escuela">', "");
    str = str.replace('<span class="carrera-tecnica">', "");
    text.innerHTML = "";

    //Declaramos una varible en la que asignaremos un valor para que sea el tiempo en ms que durará la función setTimeout
    let i = 0;

    //Esta función recorre todos los caracteres nuestro texto
    const typeWriter = () => {
    if (i < str.length) {
        text.innerHTML += str.charAt(i);
        i++;
        setTimeout(typeWriter, speed);
    }
    };

    //Acá ejecutamos la función
    setTimeout(typeWriter, speed);
}








// function toogleMostrarOcultar(){
//     const nav = document.querySelector('.navegacion');
//     const estado = navegacion.classList.value.includes('ocultar-nav');

//     if(estado){
//         nav.classList.remove('ocultar-nav');
//         nav.classList.add('mostrar-nav');
//     }else{
//         nav.classList.add('ocultar-nav');
//         nav.classList.remove('mostrar-nav');            
//     }
// }